const { plane: createPlane } = require("primitive-geometry");
const edges = require("geom-edges");
const { mat4 } = require("pex-math");

function createDrawGridCmd(ctx) {
  const geom = createPlane({ sx: 1, sy: 1, nx: 10, ny: 10 }, { quads: true });

  //flip XY to XZ
  //geom.positions = geom.positions.map((p) => [p[0], p[2], p[1]]);
  geom.cells = edges(geom.cells);

  const drawCmd = {
    pipeline: ctx.pipeline({
      vert: /*glsl*/ `
        attribute vec3 aPosition;

        uniform mat4 uProjectionMatrix;
        uniform mat4 uViewMatrix;
        uniform mat4 uModelMatrix;

        void main () {        
          gl_Position = uProjectionMatrix * uViewMatrix * uModelMatrix * vec4(aPosition, 1.0);
        }
        `,
      frag: /*glsl*/ `
        precision highp float;     
        uniform vec4 uColor;
          
        void main () {
          gl_FragData[0] = uColor;
        }
      `,
      depthTest: true,
      depthWrite: true,
      primitive: ctx.Primitive.Lines,
    }),
    attributes: {
      aPosition: ctx.vertexBuffer(geom.positions),
    },
    indices: ctx.indexBuffer(geom.cells),
  };

  let modelMatrix1 = mat4.create();

  let modelMatrix10 = mat4.create();
  mat4.scale(modelMatrix10, [10, 10, 10]);

  let modelMatrix100 = mat4.create();
  mat4.scale(modelMatrix100, [100, 100, 100]);

  return function drawGridCmd({ camera }) {
    ctx.submit(drawCmd, [
      {
        uniforms: {
          uProjectionMatrix: camera.projectionMatrix,
          uViewMatrix: camera.viewMatrix,
          uModelMatrix: modelMatrix1,
          uColor: [1, 0, 0, 1],
        },
      },
      {
        uniforms: {
          uProjectionMatrix: camera.projectionMatrix,
          uViewMatrix: camera.viewMatrix,
          uModelMatrix: modelMatrix10,
          uColor: [1, 0, 0, 1],
        },
      },
      {
        uniforms: {
          uProjectionMatrix: camera.projectionMatrix,
          uViewMatrix: camera.viewMatrix,
          uModelMatrix: modelMatrix100,
          uColor: [1, 0, 0, 1],
        },
      },
    ]);
  };
}

export default createDrawGridCmd;
